// Fronta window.cgQueue — aplikace může volat API dřív, než se skript načte
// (vzor googletag.cmd). Spouští jen funkce, stringy se nikdy nevyhodnocují.

type QueueHost = { cgQueue?: unknown };

/**
 * Spustí funkce, které už čekají ve win.cgQueue, a frontu nahradí objektem,
 * jehož push(fn) spustí funkci hned.
 */
export function installQueue<T>(win: Window, api: T): void {
  const host = win as unknown as QueueHost;
  const pending = host.cgQueue;
  if (Array.isArray(pending)) {
    pending.forEach((fn) => run(fn, api));
  } else if (pending !== undefined) {
    console.warn('[CookieGobbler] cgQueue není pole — ignoruji.');
  }
  host.cgQueue = {
    push(fn: unknown): number {
      run(fn, api);
      return 0;
    },
  };
}

function run<T>(fn: unknown, api: T): void {
  if (typeof fn !== 'function') {
    console.warn('[CookieGobbler] cgQueue: prvek není funkce — ignoruji.');
    return;
  }
  // Chyba v cizím callbacku nesmí shodit embed ani další prvky fronty.
  try {
    (fn as (api: T) => void)(api);
  } catch (e) {
    console.error('[CookieGobbler] cgQueue callback selhal:', e);
  }
}
